import React, { Component } from "react";
import ItemMasterServices from "../../services/axioServices/apiServices/ItemMasterServices.js";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import SwalServices from "../../services/swalServices/SwalServices.js";

class PMCategoryMaster extends Component {
  constructor(props) {
    super(props);
    this.itemMasterServices = new ItemMasterServices();
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.state = {
      _id: "",
      isEditing: false,
      isLoading: false,
      tableStatus: "",
      pmCategoryListing: [],
      pmCategoryDetails: {
        pmCategory: "",
      },
    };
  }

  componentDidMount() {
    this.getAllPMCategory();
  }

  getAllPMCategory = () => {
    this.setState({ tableStatus: "Loading..." })
    this.commonServices.getAllPMCategory().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        if (response.responseData.length === 0) {
          this.setState({ tableStatus: "No Record Found" })
        } else {
          this.setState({ tableStatus: "" })
        }
        this.setState(
          { pmCategoryListing: response.responseData });
      } else {
        this.setState({ tableStatus: "" })
        this.SwalServices.Error(response.Message);
      }
    });
  };

  addEditPMCategory = () => {
    if (this.state.pmCategoryDetails.pmCategory !== "") {
      this.setState({ isLoading: true }, () => {
        let request = this.state.pmCategoryDetails;
        if (this.state._id && this.state._id !== "") {
          request._id = this.state._id;
        } else {
          delete request._id;
        }
        this.itemMasterServices.addEditPMCategory(request).then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            this.SwalServices.Success(response.Message);
            this.getAllPMCategory();
            this.resetForm();
            this.setState({ isLoading: false })
          } else {
            this.SwalServices.Error(
              response.Message
            );
            this.setState({ isLoading: false })
          }
        });
      })
    } else {
      this.SwalServices.Alert("Please fill all the required things.");
    }
  };

  resetForm = () => {
    let details = this.state.pmCategoryDetails;
    details.pmCategory = "";
    this.setState({ pmCategoryDetails: details, _id: "", tableStatus: "", isEditing: false });
  };

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.pmCategoryDetails;
    details[name] = value.toUpperCase();
    this.setState({ pmCategoryDetails: details });
  };

  getCategoryById = (group) => {
    let details = this.state.pmCategoryDetails;
    details.pmCategory = group.pmCategory;
    this.setState({ pmCategoryDetails: details, _id: group._id }, () => {
      this.setState({ isEditing: true });
    });
  };

  deletePMCategoryById = (id) => {
    this.itemMasterServices.deletePMCategoryById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.SwalServices.Success(response.Message);
        this.resetForm();
        this.getAllPMCategory();
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  closeGridView = () => {
    this.resetForm();
  };

  render() {
    return (
      <div className="item-category">
        <div className="item-form">
          <div className="form-table">
            <div className="item-grp w-[50%] !mb-3.5">
              <label>P.M. Category</label>
              <input
                className="inputFocus"
                type="text"
                id="pmCategory"
                name="pmCategory"
                autoComplete="off"
                value={this.state.pmCategoryDetails.pmCategory}
                onChange={(event) => this.handleChange(event, "pmCategory")}
              />
            </div>
            <div className="btn-grp">
              {this.state.isEditing === true ? (
                <button
                  className="add-btn"
                  disabled={this.state.isLoading}
                  onClick={() => this.addEditPMCategory()}
                >
                  {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                </button>
              ) : (
                <button
                  className="add-btn"
                  disabled={this.state.isLoading}
                  onClick={() => this.addEditPMCategory()}
                >
                  {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                </button>
              )}
              <button className="cancel-btn" onClick={() => this.closeGridView()} disabled={this.state.isLoading}>
                cancel
              </button>
            </div>
          </div>
          <div className="itemList-table !w-[60%] mt-4">
            <div className="table-container" style={{ height: 'calc(100vh - 185px)', }}>
              <table className="itemList ">
                <thead>
                  <tr>
                    <td style={{ width: '85%' }}>Category Name</td>
                    <td style={{ width: '15%', textAlign: 'center' }}>Action</td>
                  </tr>
                </thead>
                <tbody>
                  {this.state.pmCategoryListing &&
                    this.state.pmCategoryListing.length > 0 ?
                    this.state.pmCategoryListing.map((group, key) => (
                      <tr key={key}>
                        <td>{group.pmCategory}</td>
                        <td style={{ textAlign: 'center' }}>
                          <button
                            className="search-btn"
                            onClick={() => this.getCategoryById(group)}
                          >
                            <FontAwesomeIcon icon={faPen} />
                          </button>
                          <button
                            className="cancel-btn"
                            onClick={() => this.deletePMCategoryById(group._id)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </td>
                      </tr>
                    )) : this.state.pmCategoryListing &&
                      this.state.pmCategoryListing.length === 0
                      && this.state.tableStatus !== "" ? (
                      <tr>
                        <td colSpan={2} style={{ textAlign: "center", fontSize: "16px" }}>
                          {this.state.tableStatus}
                        </td>
                      </tr>
                    ) : this.state.pmCategoryListing &&
                      this.state.pmCategoryListing.length === 0
                      && this.state.tableStatus === "" ? null : ""}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PMCategoryMaster;
